module.exports = __webpack_public_path__ + "images/frontpage_desktop@1x.jpg?ca7dc622";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_desktop@1x.jpg
// module id = 633
// module chunks = 7